import { Action, ActionCreator } from "redux";

export enum AppActions {
    INIT = "@@app/INIT"
}

export type IAppAction = IAppInitAction;

export type IAppInitAction = Action<AppActions.INIT>;

export const appInit: ActionCreator<IAppInitAction> = (): { type: AppActions } => ({ type: AppActions.INIT });

